<template>
	<div class="p-3">
		<follower-goal-settings-content />
	</div>
</template>

<script>
import FollowerGoalSettingsContent from '@/components/Widget/FollowerGoalSettingsContent.vue';

export default {
	components: { FollowerGoalSettingsContent },
	created() {
		this.$auth.loadFromLocalStorage();
		if(!this.$auth.isLoggedIn()) {
			document.location = `${process.env.VUE_APP_PIPIPUPUBASE}/app?redirect=${document.location}`;
		}
	},
};
</script>

<style>
html, body, #app {
	margin: 0;
	padding: 0;
}
</style>
